
import {TbReport} from "react-icons/tb";

export const sidebarData = [
    {
        name: "Meetings",
        icon: <TbReport />,
        routes: "/meetings"
    },
    // {
    //     name: "Invoices",
    //     icon: <FaFileInvoice />,
    //     routes: "/invoice"
    // },
    // {
    //     name: "Operator",
    //     icon: <CgProfile />,
    //     routes: "/operatorList"
    // },
    // {
    //     name: "Agents",
    //     icon: <FaUserAlt />,
    //     routes: "/agentsList"
    // },

    // {
    //     name: "Game List",
    //     icon: <FaList />,
    //     routes: "/gameList"
    // },

    // {
    //     name: "Transactions",
    //     icon: <TbTransitionLeft />,
    //     routes: "/transactionList"
    // },
    // {
    //     name: "Webhook",
    //     icon: <RiWebhookFill />,
    //     routes: "/webhookList"
    // },
    // {
    //     name: "Bets",
    //     icon: <TbBeta />,
    //     routes: "/betsList"
    // },
    // {
    //     name: "Documents",
    //     icon: <IoDocuments />,
    //     routes: "/documents"
    // },
]




export const dailyData = [
    { date: '2024-10-01', profit: 300, loss: 100 },
    { date: '2024-10-02', profit: 200, loss: 50 },
    // More daily data...
];

export const weeklyData = [
    { week: 'Week 1', profit: 1500, loss: 300 },
    { week: 'Week 2', profit: 1200, loss: 500 },
    // More weekly data...
];

export const monthlyData = [
    { month: 'Jan', profit: 5000, loss: 1000 },
    { month: 'Feb', profit: 7000, loss: 1500 },
    // More monthly data...
];
